import React, { useEffect, useState } from 'react'

import { toast } from 'react-toastify'

import { useHistory, useParams } from 'react-router-dom'

import axios from 'axios'
import Plans from '../../../../../presentation/pages/common/plans'

import { useMe } from '../../../../../presentation/contexts/me'

import { makePlansPublic } from '../../../../usecases/plans/remote-plans-factory'
import { makeContractors } from '../../../../usecases/contractors/remote-contractors-factory'
import { makeDoctors } from '../../../../usecases/doctors/remote-doctors-factory'

import IRouteParams from '../../../../../presentation/interfaces/route-params'

import { isHttpError, getRoute } from '../../../../../presentation/helpers'
import { RoutesEnum } from '../../../../../presentation/enums'

import { settings } from '../../../../configs/settings'

const MakePlans = () => {
  document.title = 'BuscarMédicos - Planos'

  const [selectedPlan, setSelectdPlan] = useState<number>(0)
  const [userPlan, setUserPlan] = useState<number>(0)

  const [plans, setPlan] = useState([])

  const { me } = useMe()

  const history = useHistory()

  const { type } = useParams<IRouteParams>()

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await makePlansPublic().load({ type })
        const responsePlans = response.content.map((item: any) => ({
          id: item.id,
          planTitle: item.planTitle,
          values: item.values,
          period: item.period,
          promotionalPrice: item.promotionalPrice,
        }))
        setPlan(responsePlans)
      } catch (error) {
        toast.error('Erro ao carregar planos.')
      }
    }

    fetchData()
  }, [])

  useEffect(() => {
    const loadUserPlan = async () => {
      try {
        if (!me) {
          return
        }

        const remote = type === 'MEDICO' ? makeDoctors() : makeContractors()

        const data = await remote.loadById(me.id as number)
        setSelectdPlan(data.plan?.id)
        setUserPlan(data.plan?.id)
      } catch (error) {
        const httpError = isHttpError(error)

        if (httpError) {
          toast.error(httpError.message)
        } else {
          throw error
        }
      }
    }

    loadUserPlan()
  }, [me])

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    history.push(
      getRoute(RoutesEnum.CHECKOUT, { type, id: String(selectedPlan) }),
    )
  }

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectdPlan(Number(event.target.value))
  }

  const handleCancelPlan = async () => {
    try {
      if (!me) {
        return
      }

      const tokenKey: any = Object.keys(localStorage).find((key) => key.endsWith('.idToken'))
      const token = localStorage.getItem(tokenKey)

      if (!token) {
        console.error('Token não encontrado')
        return
      }

      const cancelRoute = type === 'MEDICO'
        ? `doctor/cancel-user-plan-subscription/${me.id}`
        : `contractors/cancel-user-plan-subscription/${me.id}`

      await axios.post(`${settings.API_URL}/${cancelRoute}`, null, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      history.push('/intro')
    } catch (error) {
      console.error('Erro ao cancelar a assinatura:', error)
    }
  }

  const plansProps = {
    states: {
      plans,
      selectedPlan,
      userPlan,
    },
    handlers: {
      handleSubmit,
      handleRadioChange,
      handleCancelPlan,
    },
  }

  return <Plans {...plansProps} />
}

export default MakePlans
